import { IonButton, IonInput, IonLabel, IonList, IonItem, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar 
  ,IonGrid, IonModal, IonBackButton, IonThumbnail
  ,IonRow, IonCard , IonCardSubtitle, IonCardTitle, IonCardContent
  ,IonCol, IonItemOptions, IonItemOption, IonImg, IonCardHeader, IonItemDivider, IonAlert
  ,IonListHeader, IonToggle, IonRadio, IonCheckbox, IonItemSliding, IonIcon, IonFooter, IonSegment, IonSegmentButton} from '@ionic/react';

import { close, checkmark, qrCodeOutline, arrowRedo, chevronBack, closeCircle  } from 'ionicons/icons';
import React, { useState, useEffect, Component } from 'react';
//import { useParams } from 'react-router';
import './Dar.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import QrReader from 'react-qr-reader'
import ServerService from '../../../services/Server';

const Dar: React.FC = () => {
  const name:string = "B1 DAR";
  const [actionId, setActionId] = useState("");
  const now = new Date();
  const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();
  type Item = {
   src: string;
   text: string;
   id: string;
 };
 const items: Item[] = [
   { src: 'assets/img/stamp.png', text: 'Check Version', id: "0" }
  ,{ src: 'assets/img/dochistory.png', text: 'History', id: "1" }
 ];
 
 
 useEffect(() => {
     
 }, [actionId])
 const rountTo = function(id:any) {
    if(id=="0"){
      return "darForm/0";
    }else if(id=="1"){
     return "darHistory/0";
    }
 }




  return (
    <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton />
          <OpenMenuButton />
        </IonButtons>
        <IonTitle>{name}</IonTitle>
      </IonToolbar>
    </IonHeader>

    <IonContent>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>
   
  <IonList>
    {items.map((image, i) => (
      <IonItem key={i}  routerLink={"/page/home/dar/"+rountTo(image.id)+"/"+dummy} onClick={(e) => {}} >
        <IonThumbnail slot="start">
          <IonImg src={image.src} />
        </IonThumbnail>
        <IonLabel>{image.text}</IonLabel>
      </IonItem>
     
    ))}
  </IonList>

    </IonContent>
 
  </IonPage>
  );
};

export default Dar;
